import axios from 'axios'

export const INVESTMENT_GOVERNANCE_POSITION_URL = '/api/digital-risk/investment-governance/position/'

export async function fetchInvestmentGovernancePosition() {
  const { data } = await axios.get(INVESTMENT_GOVERNANCE_POSITION_URL, { withCredentials: true })
  return data
}
